import React from 'react';
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

class RequestReset extends React.Component {
   state = {
      email: '',
      success: false
   }

   handleChange(event) {
      this.setState({ [event.target.name]: event.target.value })
   }

   requestReset() {
      axios.post('/auth/reset/request', {
         email: this.state.email,
      })
         .then(data => {
            this.setState({ success: true })
         })
         .catch(err => {
            console.error(err)
            Rollbar.error(err)
            toast.error('Failed to request password reset email')
         })
   }

   render() {
      return (
         <div className="text-center">
            <form className="form-signin" onSubmit={e => e.preventDefault()}>
            <img className="mb-4" src="/logo.png" alt="" width="300" />
            <h1 className="h3 mb-3 font-weight-normal">Reset Password</h1>
            {this.state.success ?
            <p className="mt-3 mb-1">
               You will shortly receive an email containing a link to reset your password. Please note that this email will expire in 24 hours.
            </p> :
            <span>
               <label for="inputEmail" className="sr-only">Email address</label>
               <input type="email" id="inputEmail" className="form-control" placeholder="Email address" name="email" value={this.state.email} onChange={this.handleChange.bind(this)} />
               <button className="mt-3 btn btn-lg btn-primary btn-block" type="submit" onClick={this.requestReset.bind(this)}>Submit</button>
               <p className="mt-3 mb-1">Remember your login details?<a href="#fix" onClick={this.props.showLogin}> Sign in</a></p> 
            </span>}
            <p className="mt-3 mb-3 text-muted">&copy; {new Date().getFullYear()} OrderFresh</p>
            </form>
         </div>
    )
   }
}

export default RequestReset;
